import { createContext, useContext, useEffect, useState } from 'react';

const DarkModeContext = createContext();

export const useDarkMode = () => {
  const context = useContext(DarkModeContext);
  if (!context) {
    throw new Error('useDarkMode must be used within a DarkModeProvider');
  }
  return context;
};

export default function DarkModeProvider({ children }) {
  // خواندن از localStorage یا استفاده از حالت پیش‌فرض سیستم
  const [isDark, setIsDark] = useState(() => {
    // اول چک کن localStorage
    const saved = localStorage.getItem('darkMode');
    if (saved !== null) {
      return saved === 'true';
    }
    // اگر در localStorage نبود، از تنظیمات سیستم استفاده کن
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // اعمال کلاس dark به root element در اولین رندر (قبل از اینکه صفحه نمایش داده شود)
  useEffect(() => {
    const root = document.documentElement;
    const saved = localStorage.getItem('darkMode');
    let shouldBeDark = false;

    if (saved !== null) {
      shouldBeDark = saved === 'true';
    } else {
      shouldBeDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    if (shouldBeDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, []);

  useEffect(() => {
    // ذخیره در localStorage
    localStorage.setItem('darkMode', isDark.toString());

    // اضافه یا حذف کلاس dark از root element
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [isDark]);

  // گوش دادن به تغییرات سیستم
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      // فقط اگر کاربر به صورت دستی تنظیم نکرده باشد
      if (localStorage.getItem('darkMode') === null) {
        setIsDark(e.matches);
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const toggleDarkMode = () => {
    setIsDark((prev) => !prev);
  };

  const setDarkMode = (value) => {
    setIsDark(value);
  };

  return (
    <DarkModeContext.Provider
      value={{
        isDark,
        toggleDarkMode,
        setDarkMode,
      }}
    >
      {children}
    </DarkModeContext.Provider>
  );
}
